export const PAGE_BANNER_TEST_IDS = {
  titleContainer: 'page-banner-title-container',
  titleSlot: 'page-banner-title-slot',
  titleText: 'page-banner-title-text',
  titleMetaSlot: 'page-banner-title-meta-slot',
  titleMetaPinnedSlot: 'page-banner-title-meta-pinned-slot',
  titleMeasure: 'page-banner-title-measure',
};
